import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'aura-chat-bubble',
  imports: [CommonModule, MatIconModule, MatMenuModule, MatButtonModule, MatTooltipModule],
  templateUrl: './chat-bubble.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraChatBubbleComponent {
  text = input.required<string>();
  isMe = input<boolean>(false);
  showAvatar = input<boolean>(false);
  participantInitial = input<string>('');
  isFirstInGroup = input<boolean>(false);
  isLastInGroup = input<boolean>(true);
  isSameGroupAsPrevious = input<boolean>(false);
  time = input<string>('');
  showDelete = input<boolean>(false);
  replyToText = input<string | null>(null);
  replyToSenderName = input<string | null>(null);
  isReplyingTo = input<boolean>(false);
  sending = input<boolean>(false);
  failed = input<boolean>(false);
  isReadByAll = input<boolean>(false);
  errorMessage = input<string | null>(null);

  reply = output<void>();
  replyToClick = output<void>();
  copyText = output<void>();
  pin = output<void>();
  info = output<void>();
  delete = output<void>();
  retry = output<void>();
}
